<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="ctiyTwoProgramForm" :model="ctiyTwoProgramForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="创建时间">
              <el-date-picker clearable
                v-model="ctiyTwoProgramForm.createTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="区域名称">
             <el-input clearable v-model="ctiyTwoProgramForm.nameLike"  placeholder="请输入区域名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="城市经理">
             <el-input clearable v-model="ctiyTwoProgramForm.managerLike"  placeholder="请输入城市经理姓名或电话"></el-input>
            </el-form-item>
          </el-col>
           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="报价员">
             <el-input clearable v-model="ctiyTwoProgramForm.quoteName"  placeholder="请输入报价员"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getCityTwoList">查询</el-button>
            <el-button type="primary" @click="addCtiy">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="linkageCode"
            label="区域ID">
          </el-table-column>
          <el-table-column
            prop="linkageName"
            label="二级区域名称">
          </el-table-column>
          <el-table-column
            prop="areaNameFirst"
            label="所属一级区域">
          </el-table-column>
          <el-table-column
            prop="managerNames"
            label="所属城市经理">
          </el-table-column>
          <el-table-column
            prop="serviceProviderNames"
            label="关联回收商">
          </el-table-column>
          <el-table-column
            prop="quoteNames"
            label="关联报价员">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorCity(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteCity(scope.row)" type="text" size="small" style="color: red;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑二级区域' : '新建二级区域'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editCityOneForm" :model="editCityOneForm" :rules="editorFormRules" label-width="120px">
            <el-form-item label="区域ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editCityOneForm.linkageCode" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="二级区域名称" prop="name">
              <el-input clearable v-model="editCityOneForm.name"></el-input>
            </el-form-item>
            <el-form-item label="所属一级区域" prop="parentId">
              <el-select clearable v-model="editCityOneForm.parentId" placeholder="请选择所属一级区域">
                <el-option
                  v-for="item in prentIdOptions"
                  :key="item.id"
                  :label="item.linkageName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属城市经理" prop="managerUserIds">
              <el-select clearable
                v-model="editCityOneForm.managerUserIds"
                multiple
                filterable
                remote
                placeholder="请选择所属城市经理"
                reserve-keyword
                :remote-method.sync="getCityList"
                :loading="loading">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.id"
                  :label="item.realName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="关联回收商" prop="serviceProviderIds">
              <el-select clearable
                v-model="editCityOneForm.serviceProviderIds"
                multiple
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :loading="loading"
                @change="getQuoteUserList"
                >
                <el-option
                  v-for="item in serviceProviderIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="关联报价员" prop="quoteUserIds">
              <el-select clearable
                v-model="editCityOneForm.quoteUserIds"
                multiple
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :remote-method.sync="getQuoteUserList"
                :loading="loading">
                <el-option
                  v-for="item in quoteUserList"
                  :key="item.id"
                  :label="item.realName"
                  :value="item.id">
                </el-option>
              </el-select>
               <el-checkbox style="margin-left:10px" v-model="allSelectFlag" @change="selectAll">全部报价员</el-checkbox>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorCityDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      ctiyTwoProgramForm: {
        createTime: [],
        managerLike: '',
        nameLike: '',
        typeKey: 'area_second',
        quoteName: ''
      },

      // 日期选择插件配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: 'area_second',
      pageSize: 10,
      currentPage: 1,


      // 新建编辑对话框数据

      isDlg: false,
      editCityOneForm: {
        id: null,
        name: '',
        typeKey: 'area_second',
        parentId: null,
        linkageCode: '',
        managerUserIds: [],
        quoteUserIds: [],
        serviceProviderIds:[]
      },

      editorFormRules: {
        name: [
          { required: true, message: '请输入二级区域名称', trigger: 'change' },
        ],
        managerUserIds: [
          { required: true, message: '请选择所属城市经理', trigger: 'change' },
        ],
        parentId: [
          { required: true, message: '请选择所属一级区域', trigger: 'change' },
        ],
        // quoteUserIds: [
        //   { required: true, message: '请选择报价员', trigger: 'change' },
        // ]
      },


      dlgType: 'change',

      allSelectFlag: false,
      // 城市经理选择
      cityOptions: [],
      quoteUserList:[],
      loading: false,
      serviceProviderIdList:[],
      prentIdOptions: [],
    }
  },
  watch:{},
  computed:{},
  methods:{
    selectAll(val){
          this.editCityOneForm.quoteUserIds=[]
          if(val){
            this.quoteUserList.forEach(item=>{
              this.editCityOneForm.quoteUserIds.push(item.id)
            })
          }
    },
     getServiceProviderIdList(){
       let self = this
        self.$api.getValidHjxServiceProvider()
        .then((res) => {
           if(res.code === 200) {
            self.serviceProviderIdList = res.data
          }
        })
    },
    getQuoteUserList(){
        this.$set(this,"quoteUserList",[])
        this.editCityOneForm.quoteUserIds=[]
        this.getQuoteUserByServiceIds(this.editCityOneForm.serviceProviderIds)
      },
      getQuoteUserByServiceIds(ids){
      let self = this;
      self.$api.getQuoteUserByServiceIds({
          serviceIdsStr:ids.join(","),
        }).then((res)=>{
            self.quoteUserList = res.data;
            self.allSelectFlag = false
            if(self.editCityOneForm.quoteUserIds!=null
            &&self.editCityOneForm.quoteUserIds.length>0
            &&self.editCityOneForm.quoteUserIds.length==self.quoteUserList.length){
              self.allSelectFlag = true
            }
        });
      },
      // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getCityTwoList()
    }, 

    // 获取订单数据
    getCityTwoList() {
      let self  = this;
      self.$api.getCityAreaList({
        typeKey: self.typeKey,
        page: self.currentPage,
        size: self.pageSize,
        quoteName: self.ctiyTwoProgramForm.quoteName || null,
        managerLike: self.ctiyTwoProgramForm.managerLike || null,
        nameLike: self.ctiyTwoProgramForm.nameLike || null,
        createTimeStart: self.ctiyTwoProgramForm.createTime instanceof Array && self.ctiyTwoProgramForm.createTime.length>1 ? self.ctiyTwoProgramForm.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.ctiyTwoProgramForm.createTime instanceof Array && self.ctiyTwoProgramForm.createTime.length>1 ? self.ctiyTwoProgramForm.createTime[1] + ' 23:59:59' : null,
      }).then(res => {

        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加城市经理
    addCtiy() {
      this.dlgType = 'new'
      this.editCityOneForm = {
        id: null,
        name: '',
        typeKey: 'area_second',
        parentId: null,
        linkageCode: '',
        managerUserIds: [],
        quoteUserIds: [],
        serviceProviderIds:[]
      }
      this.$nextTick(()=>{
          this.$refs['editCityOneForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改城市经理
    editorCity(row) {
      let self = this;
      self.editCityOneForm = {
        id: null,
        name: '',
        typeKey: 'area_second',
        parentId: null,
        linkageCode: '',
        managerUserIds: [],
        quoteUserIds: [],
        serviceProviderIds:[]
      }

      self.dlgType = 'change'

      for(let i in self.editCityOneForm) {
        if(i === 'managerUserIds' ) {
          if(row.managerUserIds) {
            let arrayManager = row.managerUserIds.split(',')
            for(let j in arrayManager) {
              self.editCityOneForm.managerUserIds.push(parseInt(arrayManager[j],10))
            }
          }
        } else   if(i === 'quoteUserIds' ) {
          if(row.quoteUserIds) {
            let arrayManager = row.quoteUserIds.split(',')
            for(let j in arrayManager) {
              self.editCityOneForm.quoteUserIds.push(parseInt(arrayManager[j],10))
            }
          }
        }else   if(i === 'serviceProviderIds' ) {
          if(row.serviceProviderIds) {
            let arrayManager = row.serviceProviderIds.split(',')
            for(let j in arrayManager) {
              self.editCityOneForm.serviceProviderIds.push(parseInt(arrayManager[j],10))
            }
            this.getQuoteUserByServiceIds(self.editCityOneForm.serviceProviderIds)
          }
          this.allSelectFlag = false
        } else if(i === 'name'){
          self.editCityOneForm[i] = row.linkageName

        } else if(i === 'parentId'){
          self.editCityOneForm[i] = row.areaIdFirst
        } else {
          if(row[i]) self.editCityOneForm[i] = row[i]
        }
      }
      console.log(self.cityOptions);
      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorCityDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editCityOneForm'].validate((valid) => {
        if (valid) {
          let params = {}
          for(let i in self.editCityOneForm) {
             if(i === 'managerUserIds' || i === 'quoteUserIds' || i==='serviceProviderIds') {

              params[i] = ''

              for(let j in self.editCityOneForm[i]) {
                if(parseInt(j, 10) === (self.editCityOneForm[i].length - 1)) {
                  params[i] = `${params[i]}${self.editCityOneForm[i][j]}`
                } else {
                  params[i] = `${params[i]}${self.editCityOneForm[i][j]},`
                }
              }
            } else {
              params[i] = this.editCityOneForm[i]
            }
          }
          if(self.dlgType === 'change') {
            self.$api.changeLinkage(params.id, params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getCityTwoList()
                this.closeEditorCityDlg()
              }
            })
          } else {
            self.$api.addLinkage(params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getCityTwoList()
                this.closeEditorCityDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 获取城市经理，多选用
    getCityList(query) {
      let self = this;
      if(query) {
         self.$api.getUserList({
          type: 3,
          roleId:4,
          page: 1,
          size: 100,
          status: 1,
          userLike: query === 'init' ? '' : query ,
        }).then(res => {
          if(res.code === 200) {
            self.cityOptions = res.data.records
          }
        })
      } else {
        self.cityOptions = []
      }
    },

    // 请求一级区域列表，提供编辑时选择用
    initAreaFirstData() {
      let self = this;
      self.$api.getCityAreaList({
        typeKey: 'area_first',
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.prentIdOptions = res.data.records
        }
      
      })
    },

    //删除区域
    deleteCity(row) {
      let self = this;
      self.$confirm('是否删除该区域').then(() => {
        self.$api.deleteCity({
          id: row.id,
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getCityTwoList()
        })
      })
    }


  },
  created(){},
  mounted(){
    let self = this;
    self.getCityTwoList()
    self.getCityList('init')
    self.initAreaFirstData()
    self.getServiceProviderIdList()
  }
}
</script>
<style lang="less" scoped>
</style>